import { create } from 'zustand'
import { getFirestore, doc, getDoc } from 'firebase/firestore'
import { useSessionStore } from '../state'

export type AdminTab =
  | 'accreditation'
  | 'transactions'
  | 'payouts'
  | 'disputes'
  | 'diveDisputes'
  | 'support'
  | 'dives'
  | 'diveSites'
  | 'ratings'
  | 'users'
  | 'auditLog'
  | 'testData'

interface AdminState {
  activeTab: AdminTab
  setActiveTab: (tab: AdminTab) => void
  validateAdminRole: () => Promise<boolean>
}

export const useAdminStore = create<AdminState>(set => ({
  activeTab: 'accreditation',
  setActiveTab: tab => set({ activeTab: tab }),
  validateAdminRole: async () => {
    const user = useSessionStore.getState().user
    if (!user) return false
    try {
      const userDoc = await getDoc(doc(getFirestore(), 'users', user.uid))
      if (userDoc.exists() && userDoc.data().role === 'admin') {
        return true
      }
      return false
    } catch {
      return false
    }
  }
}))
